module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dev) ? _c('div', {
    staticClass: "revisions",
    class: {
      'revisions--active': _vm.active
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.active),
      expression: "!active"
    }],
    staticClass: "revisions__button",
    on: {
      "click": function($event) {
        _vm.active = true
      }
    }
  }, [_c('span'), _c('span')]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "revisions__form"
  }, [_c('div', {
    staticClass: "revisions__close",
    on: {
      "click": function($event) {
        _vm.active = false
      }
    }
  }, [_vm._v("CLOSE")]), _c('iframe', {
    attrs: {
      "src": "https://docs.google.com/forms/d/1O8sIQ6ubkxTrs5vCEGzfNxHLLK5pfEAjWdTyJ4hreZU/viewform?embedded=true",
      "frameborder": "0",
      "marginheight": "0",
      "marginwidth": "0"
    }
  }, [_vm._v("Loading...")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c953199e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/shared/revisions/revisions.pug
// module id = 594
// module chunks = 1